import { render } from "./Factions.vue?vue&type=template&id=7f4be312"
import script from "./Factions.vue?vue&type=script&lang=ts"
export * from "./Factions.vue?vue&type=script&lang=ts"
script.render = render

export default script